import { cn } from '../../lib/utils';
import React from 'react';

export function StatCard({
  details,
  totalBranches,
  AnalyticsIcon,
  buttonLabel,
  btnClassName,
  id,
  handleCancelSubmission,
  isDark,
}) {

  // Icon mapping based on AnalyticsIcon prop
  const getIconSrc = () => {
    const iconMap = {
      'bluecut': '/assets/icons/claimform.svg',
      'success': '/assets/icons/checklist.svg',
      'dangur': '/assets/icons/cancel.svg',
      'analytics': '/assets/icons/hourglass.svg',
      'review': '/assets/icons/issues.svg',
    };
    return iconMap[AnalyticsIcon] || '/assets/icons/claimform.svg';
  };

  // Icon background color mappings
  const getIconBgClass = () => {
    const lightMap = {
      bluecut: 'bg-[#072837]',
      success: 'bg-[#00a473]',
      dangur: 'bg-[#d64040]',
      analytics: 'bg-[#d8d8d8]',
      review: 'bg-[#f5a623]',
    };

    const darkMap = {
      bluecut: 'bg-[#cd6d2c]',
      success: 'bg-[#00A473]',
      dangur: 'bg-[#ff0000]',
      analytics: 'bg-[#072837]',
      review: 'bg-[#dca900]',
    };

    const map = isDark ? darkMap : lightMap;
    return map[AnalyticsIcon] || (isDark ? 'bg-[#0b3a4f]' : 'bg-[#072837]');
  };

  const getIconMaskColor = () => {
    const lightMap = {
      bluecut: '#ffffff',
      success: '#ffffff',
      dangur: '#ffffff',
      analytics: '#072837',
      review: '#ffffff',
    };

    const darkMap = {
      bluecut: '#072837',
      success: '#072837',
      dangur: '#072837',
      analytics: '#d9d9d9',
      review: '#072837',
    };

    const map = isDark ? darkMap : lightMap;
    return map[AnalyticsIcon] || (isDark ? '#ffffff' : '#ffffff');
  };

  const handleCancel = (e) => {
    e.stopPropagation();
    if (handleCancelSubmission && id) {
      handleCancelSubmission(id);
    }
  };

  // Format time from HH:MM:SS to MM:SS for display (if it's a time string)
  const formatTimeDisplay = (value) => {
    if (details === 'Time to cancel on latest submission' && value && value.includes(':')) {
      const parts = value.split(':');
      if (parts.length === 3) {
        // If HH:MM:SS format, show only MM:SS
        return `${parts[1]}:${parts[2]}`;
      }
    }
    return value;
  };

  return (
    <div
      className={cn(
        "rounded-[16px] sm:rounded-[20px] p-[16px] sm:p-[20px] flex flex-col justify-between gap-[16px] sm:gap-[18px] h-full min-h-[160px] sm:min-h-[180px] transition-colors duration-200 border-solid border-[1px]",
        isDark ? 'bg-[#161515] border-[#292929]' : 'bg-white border-[#d9d9d9]'
      )}
    >
      {/* Icon and Details */}
      <div className={cn("flex flex-col gap-[12px] sm:gap-[16px]")}>
        {/* Icon */}
        <div className={cn(
          "rounded-[8px] w-[24px] h-[24px] flex items-center justify-center",
          getIconBgClass()
        )}>
          <div
            className={cn("w-[16px] h-[16px]")}
            style={{
              backgroundColor: getIconMaskColor(),
              WebkitMaskImage: `url(${getIconSrc()})`,
              WebkitMaskSize: 'contain',
              WebkitMaskRepeat: 'no-repeat',
              WebkitMaskPosition: 'center',
              maskImage: `url(${getIconSrc()})`,
              maskSize: 'contain',
              maskRepeat: 'no-repeat',
              maskPosition: 'center',
            }}
            aria-hidden="true"
          />
        </div>

        {/* Details Text */}
        <p
          className={cn(
            "text-[14px] sm:text-[16px] font-medium m-0 leading-tight transition-colors duration-200",
            isDark ? 'text-[#b3b3b3]' : 'text-[#686868]'
          )}
        >
          {details}
        </p>
      </div>
      {/* Value and Button Row */}
      <div className={cn("flex gap-[12px] sm:gap-[18px] items-center ")}>
        {/* Value */}
        <p
          className={cn(
            "flex-1 text-[18px] sm:text-[20px] font-bold m-0 transition-colors duration-200",
            isDark ? 'text-white' : 'text-[#072837]'
          )}
        >
          {formatTimeDisplay(totalBranches)}
        </p>

        {/* Cancel Button (only for Time to cancel) */}
        {buttonLabel === 'Cancel' && id && (
          <div className={cn("bg-[#fcd8d8] px-[12px] sm:px-[16px] py-[6px] rounded-[8px] shadow-sm")}>
            <button
              onClick={handleCancel}
              className={cn(
                "text-[11px] sm:text-[12px] font-medium border-0 outline-none bg-transparent cursor-pointer",
                btnClassName || 'text-red-600'
              )}
            >
              {buttonLabel}
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

